// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Qqiry","description":"PatientConsentPreview_description__xQNgr"};